import type {ReactElement} from 'react';
import React, { useEffect, useRef} from 'react';
import styles from './fancy-text-list-item.module.scss';

interface FancyTextListItemProps {
  className?: string;
  id: string;
  imgSrc: string;
  isSelected?: boolean;
  onClick(): void;
  doScrollIntoView?: boolean;
}

export function FancyTextListItem({className = '', isSelected = false, doScrollIntoView = false, ...props}: FancyTextListItemProps): ReactElement<any> {
  const ref = useRef<HTMLLIElement>(null);
  const getListItemContainer = (): ReactElement<any> => {
    return <img loading="lazy" className={styles.img} src={props.imgSrc} alt={window.i18next.t('pmwjs_image')} />;
  };

  useEffect(() => {
    if (ref && ref.current && doScrollIntoView && isSelected) {
      ref.current?.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  }, [isSelected, doScrollIntoView]);

  const onClickHandler = (): void => {
    props.onClick();
  };

  return (
    <li
      ref={ref}
      id={props.id}
      onClick={onClickHandler}
      className={`${styles.container} spacing-p-l-2 spacing-p-b-0 ${isSelected ? styles.selectedContainer : ''} radius-4 _full-width ${className}`}
    >
      {getListItemContainer()}
    </li>
  );
}
